import {AgencyRepositoryType} from "../../../repositories/interfaces/AgencyRepositoryType.ts";

export class DeleteAgencyObservationUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string, observationId: string): Promise<void> {
        return this.agencyRepository.deleteAgencyObservation(agencyId, observationId)
    }
}
